import { render, staticRenderFns } from "./MasterpieceRecieved.vue?vue&type=template&id=2a546f88&scoped=true&"
import script from "./MasterpieceRecieved.vue?vue&type=script&lang=js&"
export * from "./MasterpieceRecieved.vue?vue&type=script&lang=js&"
import style0 from "./MasterpieceRecieved.vue?vue&type=style&index=0&id=2a546f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a546f88",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AddMasterpieceAnimation: require('/home/bitrix/frontend/components/masterpiece/AddMasterpieceAnimation.vue').default,MtArrowLink: require('/home/bitrix/frontend/components/other/MtArrowLink.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
